<template>
  <v-footer
    :class="$style.footer"
    color="#fff"
  >
    <div :class="$style.cols">
      <div :class="$style.leftCol">
        <v-btn
          href="https://www.atol.ru/"
          color="primary darken-3"
          text
          target="_blank"
        >
          atol.ru
        </v-btn>
        <v-btn
          href="https://fs.atol.ru/"
          color="primary darken-3"
          text
          target="_blank"
        >
          Центр загрузок
        </v-btn>
        <!-- <v-btn
          href="https://forum.atol.ru/"
          color="primary darken-3"
          text
          target="_blank"
        >
          Форум АТОЛ
        </v-btn> -->
      </div>
      <div :class="$style.rightCol">
        <v-btn
          href="tel:+74957307420"
          color="primary darken-3"
          text
        >
          +7 (495) 730-74-20
        </v-btn>
        <v-btn
          href="mailto:lkp@atol.ru"
          color="primary darken-3"
          text
          class="mr"
        >
          lkp@atol.ru
        </v-btn>
        <!-- <v-btn
          color="primary darken-3"
          outlined
        >
          <span class="primary--text text--darken-1">
            Обращения
          </span>
        </v-btn> -->
      </div>
    </div>
  </v-footer>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FooterApp extends Vue {

}
</script>

<style module lang="scss">
.footer {
  margin-top: 20px;
}

.cols {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
